<div class="panel" [ngClass]="{'pdf-view': pdfView}">
    <div class="panel-heading py-2 px-3">
        <h4>{{ 'UNALLOCATED_TASKS' | translate }}</h4>
        <span class="d-flex align-items-center">
             &nbsp;|&nbsp;
        </span>
        <span>
             <span class="fw-700">{{ totalUnallocatedTasks }}</span> {{ 'UNALLOCATED' | translate }}
        </span>
        @if (isSplitUnallocated) {
            <app-tooltip
                class="ml-2"
                appCustomPopover
                placement="right"
                popoverText="SPLIT_SHIFT_NOT_ALLOCATED"
            >
                <ng-container icon>
          <span
              class="vismaicon vismaicon-sm vismaicon-filled vismaicon-warning"
          ></span>
                </ng-container>
            </app-tooltip>
        }
    </div>
    <div class="panel-body pb-4 px-3">
        <app-table
            [ngClass]="{'pdf-view': pdfView}"
            class="unallocated-tasks-table"
            [loadingItems]="loading"
            [loadingTable]="updating || saving"
            [loadingTableText]="updating ? 'ESTIMATING_NEW_VISITING_TIMES' : ''"
        >
            <ng-container header>
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'NAME' | translate }}</span>
                </th>
                <th class="flex-3" appTitleProvider>
                    <span>{{ 'TASK' | translate }}</span>
                </th>
                @if (showRoster && !pdfView) {
                    <th class="flex-2" appTitleProvider>
                        <span>{{ 'ROSTER_NAME' | translate }}</span>
                    </th>
                }
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'TIME' | translate }}</span>
                </th>
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'DURATION' | translate }}</span>
                </th>
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'SHIFT_TYPE' | translate }}</span>
                </th>
                <th class="flex-1 justify-content-center" appTitleProvider>
                    <span>{{ 'CAUSE' | translate }}</span>
                </th>
                <th class="icon-column three"></th>
                <th class="icon-drag-column"></th>
            </ng-container>
            <ng-container body>
                <div
                    #dropListContainer
                    cdkDropList
                    cdkDropListSortingDisabled
                    [cdkDropListData]="tasks"
                    [cdkDropListDisabled]="dragDisabled"
                    (cdkDropListEntered)="entered($event)"
                    (cdkDropListDropped)="taskDropped($event)"
                >
                    @for (task of tasks; track task.routePlannerTaskId) {
                        <tr
                            cdkDrag
                            [cdkDragData]="task"
                            [cdkDragDisabled]="task.disabledPermanently"
                            (cdkDragStarted)="started($event)"
                            (cdkDragReleased)="released()"
                            (contextmenu)="openModalWindow(task, $event)"
                            (contextmenu)="getMousePosition($event)"
                            [ngClass]="{'shift-split': task.isShiftSplitTask,
                                        'colored': task.color}"
                            [ngStyle]="{'border-color': task.color }"
                            id="shift-split"
                        >
                            <td class="flex-2">
                                <span appTitleProvider>{{ task.name }}</span>
                            </td>
                            <td class="flex-3">
                                <span appTitleProvider>{{ task.serviceName }}</span>
                            </td>
                            @if (showRoster && !pdfView) {
                                <td class="flex-2">
                                    <span appTitleProvider>{{ task.rosterDepartmentName }}</span>
                                </td>
                            }
                            <td class="flex-2">
                                <span appTitleProvider> {{ task | fromto }} </span>
                            </td>
                            <td class="flex-2">
                                <span appTitleProvider>{{ task.duration }} min</span>
                            </td>
                            <td class="flex-2">
                                <span appTitleProvider>{{ task.shiftType }}</span>
                            </td>
                            <td class="flex-1">
                                @if (task.feasibilityInfo) {
                                    <app-feasibility-info
                                        [showOvertime]="true"
                                        [feasibilityInfo]="task.feasibilityInfo"
                                    ></app-feasibility-info>
                                }
                            </td>
                            <td class="icon-column three">
                                @if (task.isHeavy) {
                                    <app-tooltip
                                        class="ml-1"
                                        appCustomPopover
                                        popoverText="TASK_HEAVY_INFO"
                                        placement="top"
                                        [adaptPlacement]="true"
                                    >
                                        <ng-container icon>
                                            <span class="icon-heavy-weight"></span>
                                        </ng-container>
                                    </app-tooltip>
                                }
                                @if (task.isSynced) {
                                    <app-tooltip
                                        class="ml-1"
                                        appCustomPopover
                                        [popoverText]="task.singleSyncedTask ? 'SYNCED_TASK_NOT_PAIRED_ICON_TOOLTIP' : 'TASK_SYNCED_INFO_DELETE_MRP_UNALLOCATED'"
                                        placement="top"
                                        [adaptPlacement]="true"
                                    >
                                        <ng-container icon>
                                            <span class="icon-merge"></span>
                                        </ng-container>
                                    </app-tooltip>
                                }
                                @if (task.doesRequirePhysicalAppearance === false) {
                                    <app-tooltip
                                        class="ml-1"
                                        appCustomPopover
                                        popoverText="TASK_REQUIRE_PHYSICAL_APPEARANCE_INFO"
                                        placement="top"
                                        [adaptPlacement]="true"
                                    >
                                        <ng-container icon>
                                            <span class="icon-phone"></span>
                                        </ng-container>
                                    </app-tooltip>
                                }
                                @if (task.singleSyncedTask) {
                                    <app-tooltip
                                        class="ml-1"
                                        appCustomPopover
                                        popoverText="SYNCED_TASK_NOT_PAIRED_ICON_TOOLTIP"
                                        placement="top">
                                        <ng-container icon>
                                            <span class="vismaicon vismaicon-sm icon-warning-multicolor-orange"></span>
                                        </ng-container>
                                    </app-tooltip>
                                    }
                            </td>
                            <td class="icon-drag-column">
                                @if (task.disabledPermanently === false && !dragDisabled) {
                                    <app-tooltip
                                        title="{{ 'DRAG_TASK' | translate}}"
                                    >
                                        <ng-container icon>
                                            <span class="vismaicon icon-draggable-indicator"></span>
                                        </ng-container>
                                    </app-tooltip>
                                }
                            </td>
                        </tr>
                    }
                    @if (showRestrictionContextMenu) {
                        <div
                            class="context-menu"
                            (click)="openEmployeesRestrictionModal()"
                            [style.top.px]="showRestrictionContextMenuTopPosition"
                            [style.left.px]="showRestrictionContextMenuLeftPosition"
                        >
                            <span class="vismaicon vismaicon-users vismaicon-no-hover"></span>
                            {{ 'SHOW_RESTRICTIONS' | translate }}
                        </div>
                    }
                </div>
            </ng-container>
        </app-table>
    </div>
</div>
